export const TIRE_SEASON = {
  SUMMER: 'SUMMER',
  WINTER: 'WINTER',
  NONE: 'NONE'
} as const;

export type TireSeason = (typeof TIRE_SEASON)[keyof typeof TIRE_SEASON];

export const fleetTreadDepthStatus = {
  WORN_OUT: 'WORN_OUT',
  SOON_WORN_OUT: 'SOON_WORN_OUT',
  ABOVE_RECOMMENDED: 'ABOVE_RECOMMENDED',
  NO_MEASUREMENTS: 'NO_MEASUREMENTS'
} as const;

export type FleetTreadDepthStatus = (typeof fleetTreadDepthStatus)[keyof typeof fleetTreadDepthStatus];
